export function createLogRetrievalRequestId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `lr-${crypto.randomUUID()}`;
  }
  return `lr-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function buildLogRetrievalRequestPayload(
  targetType,
  targetValue,
  days,
  platform,
  requestId
) {
  const value = String(targetValue || "").trim();
  if (!value) {
    throw new Error(targetType === "deviceId" ? "请输入设备 ID" : "请输入用户 ID");
  }
  if (!Number.isInteger(days) || days < 1 || days > 7) {
    throw new Error("回捞天数必须在 1 到 7 天之间");
  }
  if (!["all", "android", "ios"].includes(platform)) {
    throw new Error("不支持的目标平台");
  }

  const payload = {
    days,
    platform,
    requestId: String(requestId || createLogRetrievalRequestId()).trim(),
    reason: "remote_retrieval"
  };
  if (targetType === "deviceId") {
    payload.deviceId = value;
  } else if (targetType === "userId") {
    payload.userId = value;
  } else {
    throw new Error("不支持的回捞目标类型");
  }
  return payload;
}

export function formatLogRetrievalTarget(request) {
  if (request.deviceId) return `device:${request.deviceId}`;
  if (request.userId) return `user:${request.userId}`;
  return "-";
}

export function logRetrievalStatusMeta(status) {
  const statuses = {
    pending: { label: "待领取", color: "blue" },
    received: { label: "已领取", color: "cyan" },
    uploading: { label: "上传中", color: "orange" },
    uploaded: { label: "已上传", color: "green" },
    failed: { label: "失败", color: "red" }
  };
  return statuses[status] || { label: status || "未知", color: "default" };
}
